<template>
  <button @click="onClick" :class="buttonClass" class="toggle">
    <span class="toggle__text">{{ text }}</span>
    <div class="toggle__icon">
      <div class="toggle__line toggle__line--top"></div>
      <div class="toggle__line toggle__line--middle"></div>
      <div class="toggle__line toggle__line--bottom"></div>
    </div>
  </button>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "ToggleButton",
  props: {
    text: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("products", ["getIsFetchedFilters"]),
    buttonClass() {
      let result = this.active ? "toggle--active" : "toggle--passive";
      result += this.getIsFetchedFilters ? "" : " unclickable";
      return result;
    }
  },
  methods: {
    onClick() {
      this.toggle();
    },
    toggle() {
      this.$emit("toggle");
    }
  }
};
</script>
<style scoped lang="scss">
.toggle {
  width: 173px;
  height: 30px;
  position: relative;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  border: none;
  text-align: left;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.15s ease-in;
  outline: none;
  &__text {
    font-family: "Lato", sans-serif;
    font-size: 14px;
    position: relative;
    top: -1px;
    transition: all 0.15s ease-in;
  }
  &__icon {
    position: relative;
    width: 18px;
    height: 14px;
    transition: right 0.3s ease-in-out;
  }
  &__line {
    position: absolute;
    height: 2px;
    right: 0;
    transition: transform 0.3s ease-in, width 0.1s ease-in-out;
    &--top {
      top: 0;
      width: 100%;
      transform-origin: 101% 02% 0;
    }
    &--middle {
      top: 6px;
      width: 80%;
    }
    &--bottom {
      transform-origin: 93% -330% 0;
      top: 12px;
      width: 55%;
    }
  }
}
.toggle--active {
  background-color: #f2b235;
  &:hover {
    background-color: #eba00e;
  }
  .toggle__text {
    color: #060606;
  }
  .toggle__icon {
    left: 4px;
    top: 1px;
  }
  .toggle__line {
    background-color: #060606;
  }
  .toggle__line--top {
    width: calc(85%);
    transform: rotateZ(-45deg) translateX(-30%) translateY(-237%);
  }
  .toggle__line--middle {
    opacity: 0;
  }
  .toggle__line--bottom {
    width: calc(85%);
    transform: rotateZ(45deg);
  }
}
.toggle--passive {
  background-color: #f5f5f5;
  &:hover {
    background-color: #e6e4e5;
  }
  .toggle__text {
    color: #666666;
  }
  .toggle__line {
    background-color: #c1c1c1;
  }
  .toggle__line--top {
  }
  .toggle__line--middle {
  }
  .toggle__line--bottom {
  }
}

.unclickable {
  user-select: none;
  pointer-events: none;
}
</style>
